import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../helper/apiCall';
import ENDPOINTS from '../../constants/endpoints';

// Async thunks
export const fetchPackagePlans = createAsyncThunk(
    'packagePlans/fetchPackagePlans',
    async (branchId, thunkAPI) => {
        try {
            const response = await client.get(`${ENDPOINTS.PACKAGE_PLANS.GET_LIST}?branchId=${branchId}`, {
                token: thunkAPI.getState().auth.token
            });
            // API pagination formatında döndüğü için items array'ini alıyoruz
            return response.data.items || response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const addPackagePlan = createAsyncThunk(
    'packagePlans/addPackagePlan',
    async (packagePlanData, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.PACKAGE_PLANS.CREATE, packagePlanData, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const updatePackagePlan = createAsyncThunk(
    'packagePlans/updatePackagePlan',
    async (packagePlanData, thunkAPI) => {
        try {
            const response = await client.put(ENDPOINTS.PACKAGE_PLANS.UPDATE, packagePlanData, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const deletePackagePlan = createAsyncThunk(
    'packagePlans/deletePackagePlan',
    async (id, thunkAPI) => {
        try {
            await client.delete(ENDPOINTS.PACKAGE_PLANS.DELETE.replace(':id', id), null, {
                token: thunkAPI.getState().auth.token
            });
            return id;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

const initialState = {
    packagePlans: [],
    loading: false,
    error: null,
    selectedPackagePlan: null
};

const packagePlansSlice = createSlice({
    name: 'packagePlans',
    initialState,
    reducers: {
        setSelectedPackagePlan: (state, action) => {
            state.selectedPackagePlan = action.payload;
        },
        clearSelectedPackagePlan: (state) => {
            state.selectedPackagePlan = null;
        },
        clearPackagePlans: (state) => {
            state.packagePlans = [];
            state.selectedPackagePlan = null;
        },
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        // Fetch package plans
        builder
            .addCase(fetchPackagePlans.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPackagePlans.fulfilled, (state, action) => {
                state.loading = false;
                state.packagePlans = action.payload;
            })
            .addCase(fetchPackagePlans.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Add package plan
            .addCase(addPackagePlan.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addPackagePlan.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(addPackagePlan.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Update package plan
            .addCase(updatePackagePlan.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updatePackagePlan.fulfilled, (state, action) => {
                state.loading = false;
              
            })
            .addCase(updatePackagePlan.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Delete package plan
            .addCase(deletePackagePlan.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deletePackagePlan.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deletePackagePlan.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setSelectedPackagePlan, clearSelectedPackagePlan, clearPackagePlans, clearError } = packagePlansSlice.actions;
export default packagePlansSlice.reducer; 